// GENERATED by scripts/export-hollerpost-plans.mjs. Do not edit by hand:
// change supabase/functions/_shared/hollerpostCatalog.js (Hollerpost) or the
// constants it reads for Utopian (stripe-billing, worker/core.js + routes),
// or src/brand/brands.js smsStatus, and re-run the script.
export const HOLLERPOST_PLANS = {
  "_comment": "Generated by utopian-creations-website/scripts/export-hollerpost-plans.mjs from supabase/functions/_shared/hollerpostCatalog.js, stripe-billing, the marketing worker and brands.js. Do not edit by hand.",
  "currency": "usd",
  "sms_status": "rolling_out",
  "free": {
    "slug": "hp_free",
    "name": "Free",
    "emails": 1000
  },
  "founding": {
    "percent_off": 20,
    "customers": 100
  },
  "free_ai_uses_per_month": 20,
  "ai_addon_cents": 1000,
  "rates": {
    "ses_cents_per_1000": 10,
    "card_pct": 2.9,
    "card_fixed_cents": 30,
    "mor_pct": 3.5,
    "billing_pct": 0.7,
    "stripe_pct": 7.1,
    "sms_cents_per_text": 1.1,
    "sms_number_cents": 110
  },
  "plans": [
    {
      "slug": "hp_mini",
      "name": "Mini",
      "group": "email",
      "month_cents": 800,
      "year_cents": 8000,
      "year_monthly_cents": 666.667,
      "yearly_savings_dollars": 16,
      "app_month_cents": 899,
      "app_year_cents": 8799,
      "store": {
        "apple": {
          "monthly": "hp_mini_monthly",
          "yearly": "hp_mini_yearly"
        },
        "google": {
          "product": "hp_mini",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 5000,
        "sms": 0
      }
    },
    {
      "slug": "hp_starter",
      "name": "Starter",
      "group": "email",
      "month_cents": 1500,
      "year_cents": 15000,
      "year_monthly_cents": 1250,
      "yearly_savings_dollars": 30,
      "app_month_cents": 1699,
      "app_year_cents": 16499,
      "store": {
        "apple": {
          "monthly": "hp_starter_monthly",
          "yearly": "hp_starter_yearly"
        },
        "google": {
          "product": "hp_starter",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 10000,
        "sms": 0
      }
    },
    {
      "slug": "hp_plus",
      "name": "Plus",
      "group": "email",
      "month_cents": 2900,
      "year_cents": 29000,
      "year_monthly_cents": 2416.667,
      "yearly_savings_dollars": 58,
      "app_month_cents": 3199,
      "app_year_cents": 31899,
      "store": {
        "apple": {
          "monthly": "hp_plus_monthly",
          "yearly": "hp_plus_yearly"
        },
        "google": {
          "product": "hp_plus",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 25000,
        "sms": 0
      }
    },
    {
      "slug": "hp_growth",
      "name": "Growth",
      "group": "email",
      "month_cents": 4500,
      "year_cents": 45000,
      "year_monthly_cents": 3750,
      "yearly_savings_dollars": 90,
      "app_month_cents": 4999,
      "app_year_cents": 49499,
      "store": {
        "apple": {
          "monthly": "hp_growth_monthly",
          "yearly": "hp_growth_yearly"
        },
        "google": {
          "product": "hp_growth",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 50000,
        "sms": 0
      }
    },
    {
      "slug": "hp_pro",
      "name": "Pro",
      "group": "email",
      "month_cents": 7500,
      "year_cents": 75000,
      "year_monthly_cents": 6250,
      "yearly_savings_dollars": 150,
      "app_month_cents": 8299,
      "app_year_cents": 82499,
      "store": {
        "apple": {
          "monthly": "hp_pro_monthly",
          "yearly": "hp_pro_yearly"
        },
        "google": {
          "product": "hp_pro",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 100000,
        "sms": 0
      }
    },
    {
      "slug": "hp_scale",
      "name": "Scale",
      "group": "email",
      "month_cents": 14900,
      "year_cents": 149000,
      "year_monthly_cents": 12416.667,
      "yearly_savings_dollars": 298,
      "app_month_cents": 16399,
      "app_year_cents": 163899,
      "store": {
        "apple": {
          "monthly": "hp_scale_monthly",
          "yearly": "hp_scale_yearly"
        },
        "google": {
          "product": "hp_scale",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 250000,
        "sms": 0
      }
    },
    {
      "slug": "hp_enterprise",
      "name": "Enterprise",
      "group": "email",
      "month_cents": 34900,
      "year_cents": 349000,
      "year_monthly_cents": 29083.333,
      "yearly_savings_dollars": 698,
      "app_month_cents": 38399,
      "app_year_cents": 383899,
      "store": {
        "apple": {
          "monthly": "hp_enterprise_monthly",
          "yearly": "hp_enterprise_yearly"
        },
        "google": {
          "product": "hp_enterprise",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 1000000,
        "sms": 0
      }
    },
    {
      "slug": "hp_starter_texts",
      "name": "Starter + texts",
      "group": "texts",
      "month_cents": 2900,
      "year_cents": 29000,
      "year_monthly_cents": 2416.667,
      "yearly_savings_dollars": 58,
      "app_month_cents": 3199,
      "app_year_cents": 31899,
      "store": {
        "apple": {
          "monthly": "hp_starter_texts_monthly",
          "yearly": "hp_starter_texts_yearly"
        },
        "google": {
          "product": "hp_starter_texts",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 10000,
        "sms": 500
      }
    },
    {
      "slug": "hp_growth_texts",
      "name": "Growth + texts",
      "group": "texts",
      "month_cents": 5500,
      "year_cents": 55000,
      "year_monthly_cents": 4583.333,
      "yearly_savings_dollars": 110,
      "app_month_cents": 6099,
      "app_year_cents": 60499,
      "store": {
        "apple": {
          "monthly": "hp_growth_texts_monthly",
          "yearly": "hp_growth_texts_yearly"
        },
        "google": {
          "product": "hp_growth_texts",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 50000,
        "sms": 1000
      }
    },
    {
      "slug": "hp_pro_texts",
      "name": "Pro + texts",
      "group": "texts",
      "month_cents": 9900,
      "year_cents": 99000,
      "year_monthly_cents": 8250,
      "yearly_savings_dollars": 198,
      "app_month_cents": 10899,
      "app_year_cents": 108899,
      "store": {
        "apple": {
          "monthly": "hp_pro_texts_monthly",
          "yearly": "hp_pro_texts_yearly"
        },
        "google": {
          "product": "hp_pro_texts",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 100000,
        "sms": 2500
      }
    },
    {
      "slug": "hp_scale_texts",
      "name": "Scale + texts",
      "group": "texts",
      "month_cents": 19900,
      "year_cents": 199000,
      "year_monthly_cents": 16583.333,
      "yearly_savings_dollars": 398,
      "app_month_cents": 21899,
      "app_year_cents": 218899,
      "store": {
        "apple": {
          "monthly": "hp_scale_texts_monthly",
          "yearly": "hp_scale_texts_yearly"
        },
        "google": {
          "product": "hp_scale_texts",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 250000,
        "sms": 5000
      }
    },
    {
      "slug": "hp_enterprise_texts",
      "name": "Enterprise + texts",
      "group": "texts",
      "month_cents": 37900,
      "year_cents": 379000,
      "year_monthly_cents": 31583.333,
      "yearly_savings_dollars": 758,
      "app_month_cents": 41699,
      "app_year_cents": 416899,
      "store": {
        "apple": {
          "monthly": "hp_enterprise_texts_monthly",
          "yearly": "hp_enterprise_texts_yearly"
        },
        "google": {
          "product": "hp_enterprise_texts",
          "monthly": "monthly",
          "yearly": "yearly"
        }
      },
      "quotas": {
        "email": 1000000,
        "sms": 10000
      }
    }
  ],
  "send_packs": [
    {
      "key": "hp_email_5k",
      "channel": "email",
      "amount": 5000,
      "cents": 400
    },
    {
      "key": "hp_email_10k",
      "channel": "email",
      "amount": 10000,
      "cents": 700
    },
    {
      "key": "hp_email_25k",
      "channel": "email",
      "amount": 25000,
      "cents": 1500
    },
    {
      "key": "hp_email_50k",
      "channel": "email",
      "amount": 50000,
      "cents": 2500
    },
    {
      "key": "hp_sms_250",
      "channel": "sms",
      "amount": 250,
      "cents": 500
    },
    {
      "key": "hp_sms_1k",
      "channel": "sms",
      "amount": 1000,
      "cents": 1500
    }
  ],
  "open_book": [
    {
      "slug": "hp_mini",
      "name": "Mini",
      "group": "email",
      "price_cents": 800,
      "ses_cents": 50,
      "stripe_cents": 87,
      "texts_cents": 0,
      "left_cents": 663
    },
    {
      "slug": "hp_starter",
      "name": "Starter",
      "group": "email",
      "price_cents": 1500,
      "ses_cents": 100,
      "stripe_cents": 137,
      "texts_cents": 0,
      "left_cents": 1263
    },
    {
      "slug": "hp_plus",
      "name": "Plus",
      "group": "email",
      "price_cents": 2900,
      "ses_cents": 250,
      "stripe_cents": 236,
      "texts_cents": 0,
      "left_cents": 2414
    },
    {
      "slug": "hp_growth",
      "name": "Growth",
      "group": "email",
      "price_cents": 4500,
      "ses_cents": 500,
      "stripe_cents": 350,
      "texts_cents": 0,
      "left_cents": 3650
    },
    {
      "slug": "hp_pro",
      "name": "Pro",
      "group": "email",
      "price_cents": 7500,
      "ses_cents": 1000,
      "stripe_cents": 563,
      "texts_cents": 0,
      "left_cents": 5937
    },
    {
      "slug": "hp_scale",
      "name": "Scale",
      "group": "email",
      "price_cents": 14900,
      "ses_cents": 2500,
      "stripe_cents": 1088,
      "texts_cents": 0,
      "left_cents": 11312
    },
    {
      "slug": "hp_enterprise",
      "name": "Enterprise",
      "group": "email",
      "price_cents": 34900,
      "ses_cents": 10000,
      "stripe_cents": 2508,
      "texts_cents": 0,
      "left_cents": 22392
    },
    {
      "slug": "hp_starter_texts",
      "name": "Starter + texts",
      "group": "texts",
      "price_cents": 2900,
      "ses_cents": 100,
      "stripe_cents": 236,
      "texts_cents": 660,
      "left_cents": 1904
    },
    {
      "slug": "hp_growth_texts",
      "name": "Growth + texts",
      "group": "texts",
      "price_cents": 5500,
      "ses_cents": 500,
      "stripe_cents": 421,
      "texts_cents": 1210,
      "left_cents": 3369
    },
    {
      "slug": "hp_pro_texts",
      "name": "Pro + texts",
      "group": "texts",
      "price_cents": 9900,
      "ses_cents": 1000,
      "stripe_cents": 733,
      "texts_cents": 2860,
      "left_cents": 5307
    },
    {
      "slug": "hp_scale_texts",
      "name": "Scale + texts",
      "group": "texts",
      "price_cents": 19900,
      "ses_cents": 2500,
      "stripe_cents": 1443,
      "texts_cents": 5610,
      "left_cents": 10347
    },
    {
      "slug": "hp_enterprise_texts",
      "name": "Enterprise + texts",
      "group": "texts",
      "price_cents": 37900,
      "ses_cents": 10000,
      "stripe_cents": 2721,
      "texts_cents": 11110,
      "left_cents": 14069
    }
  ]
};

// Utopian Creations' plans, for the agency dashboard only.
export const UTOPIAN_PLANS = {
  "plans": [
    {
      "slug": "mini_hosted",
      "name": "Mini",
      "month_cents": 900,
      "year_cents": 8400,
      "year_monthly_cents": 700,
      "yearly_savings_dollars": 24,
      "quotas": {
        "email": 2500,
        "sms": 0
      }
    },
    {
      "slug": "starter_hosted",
      "name": "Starter",
      "month_cents": 2400,
      "year_cents": 22800,
      "year_monthly_cents": 1900,
      "yearly_savings_dollars": 60,
      "quotas": {
        "email": 10000,
        "sms": 0
      }
    },
    {
      "slug": "growth_hosted",
      "name": "Growth",
      "month_cents": 5900,
      "year_cents": 58800,
      "year_monthly_cents": 4900,
      "yearly_savings_dollars": 120,
      "quotas": {
        "email": 50000,
        "sms": 1000
      }
    },
    {
      "slug": "scale_hosted",
      "name": "Scale",
      "month_cents": 23900,
      "year_cents": 238800,
      "year_monthly_cents": 19900,
      "yearly_savings_dollars": 480,
      "quotas": {
        "email": 500000,
        "sms": 5000
      }
    },
    {
      "slug": "enterprise_hosted",
      "name": "Enterprise",
      "month_cents": 39900,
      "year_cents": 418800,
      "year_monthly_cents": 34900,
      "yearly_savings_dollars": 600,
      "quotas": {
        "email": 1000000,
        "sms": 10000
      }
    }
  ],
  "send_packs": [
    {
      "key": "email_1k",
      "channel": "email",
      "amount": 1000,
      "cents": 300
    },
    {
      "key": "email_5k",
      "channel": "email",
      "amount": 5000,
      "cents": 1000
    },
    {
      "key": "email_10k",
      "channel": "email",
      "amount": 10000,
      "cents": 1800
    },
    {
      "key": "sms_250",
      "channel": "sms",
      "amount": 250,
      "cents": 500
    },
    {
      "key": "sms_1k",
      "channel": "sms",
      "amount": 1000,
      "cents": 1500
    }
  ]
};
